import { useState, useEffect } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements, useNavigate } from 'react-router-dom';
import RootLayouts from './components/RouteComponents/RootLayouts.js';
import TokenValidator from './components/UtilityComponents/TokenValidator.js';
import Exams from './components/ExamsComponents/Exams.js';
import Home from './components/RouteComponents/Home.js';
import { Info } from './components/InfoComponents/Info.js';
import { Contact } from './components/ContactComponents/Contact.js';
import Practice from './components/Practice/Practice.js';
import PracticeQForm from './components/Forms/PracticeQForm.js';
import ExamsForm from './components/Forms/ExamsForm.js';
import AnswerLoader from './components/Practice/AnswerLoader.js';
import ExamsResult from './components/ExamsComponents/ExamsResult.js';
import ExamsAnswerLoader from './components/ExamsComponents/ExamsAnswerLoader.js';
import Statistics from './components/StatisticsComponents/Statistics.js';
import LoginPage from './components/Auth/LoginPage.js';
import RegisterPage from './components/Auth/RegisterPage.js';
import Dashboard from './components/Auth/Dashboard.js';
import SettingsPage from './components/Auth/SettingsPage.js';



// Wrapper components to handle auth state
function LoginPageWrapper() {
  const navigate = useNavigate();
  
  const setIsLoggedIn = (value) => {
    if (value) {
      window.dispatchEvent(new Event('storage'));
    }
  };
  
  const setLoggeduser = (user) => {
    localStorage.setItem('loggedInUser', user);
  };
  
  return <LoginPage setIsLoggedIn={setIsLoggedIn} setLoggeduser={setLoggeduser} />;
}

function DashboardWrapper() {
  const [user, setUser] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const storedUser = localStorage.getItem('loggedInUser');
    if (storedUser) {
      setUser(storedUser);
    } else {
      navigate('/login');
    }
  }, [navigate]);
  
  const handleLogout = () => {
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('authToken');
    window.dispatchEvent(new Event('loginStateChange'));
    navigate('/');
  };
  
  return user ? <Dashboard user={user} handleLogout={handleLogout} /> : null;
}

function SettingsPageWrapper() {
  const [user, setUser] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const storedUser = localStorage.getItem('loggedInUser');
    if (storedUser) {
      setUser(storedUser);
    } else {
      navigate('/login');
    }
  }, [navigate]);
  
  const handleLogout = () => {
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('authToken');
    window.dispatchEvent(new Event('loginStateChange'));
    navigate('/');
  };
  
  return user ? <SettingsPage user={user} handleLogout={handleLogout} /> : null;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayouts />}>
      <Route index path='/' element={<Home />} />
      <Route path='/login' element={<LoginPageWrapper />} />
      <Route path='/register' element={<RegisterPage />} />
      <Route path='/dashboard' element={<DashboardWrapper />} />
      <Route path='/settings' element={<SettingsPageWrapper />} />
      <Route path='/exams' element={<Exams />} />
      <Route path='/info' element={<Info />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/practice' element={<Practice />} />
      <Route path='/practiceqform' element={<PracticeQForm />} />
      <Route path='/examsform' element={<ExamsForm />} />
      <Route path='/AnswerLoader' element={<AnswerLoader />} />
      <Route path='/ExamsResult' element={<ExamsResult />} />
      <Route path='/ExamsAnswerLoader' element={<ExamsAnswerLoader />} />
      <Route path='/Statistics' element={<Statistics />} />
    </Route>
  ) 
)

function App() {
  return (
    <>
      <TokenValidator />
      <main>
        <RouterProvider router={router} />
      </main>
    </>
  );
}
        
export default App;
